import { inject, computed, toRef, toRefs } from 'vue' // eslint-disable-line
import { useRoute } from 'vue-router'
import { useExploreStore } from '@/stores' // eslint-disable-line
import state from './useState'
import { storeToRefs } from 'pinia' // eslint-disable-line
import { snakeCase } from 'lodash' // eslint-disable-line

export default () => {
  const $typesense = inject('$typesense')
  const $route = useRoute()
  const { queryBy, perPage, totalHits, hits, collection } = state()

  // const selectedFilters = computed(() => {
  //   const selected = Object.entries($route.query)
  //     .filter(([key, val]) => key in state().filters.value)
  //     .map(([key, val]) => ({ key, val: Array.isArray(val) ? val : [val] }))
  //   return selected
  // })

  // const filterBy = computed(() => {
  //   const selected = selectedFilters.value.map(({ key, val }) => { // eslint-disable-line
  //     val = val.length > 1 ? `[${val.join(',')}]` : val[0]
  //     return `${key}.${snakeCase(state().filters.value[key].valueKey)}:=${val}`
  //   }).join(' && ')
  //   // return ''
  //   return 'country.iso_alpha_2:=HR || country.iso_alpha_2:=SI'
  //   // return selected
  // })

  const searchParameters = computed(() => {
    return {
      q: $route.query.q,
      per_page: perPage.value,
      query_by: queryBy.value
      // category: $route.query.category?.toString() || '',
      // filter_by: props.filter_by,
      // filter_by: Object.entries(searchParams.value.filters)
      //   .map(([k, v]) => `${k}:=${v}`)
      //   .join(' && ')
    }
  })

  const pageProvider = computed(() => { // eslint-disable-line
    // We need to trigger computed property with dependency in order to refresh returned function.
    const q = searchParameters.value.q || ''

    return async (page, per_page) => {
      if (q === '') {
        totalHits.value = 0
        hits.value = []
        return []
      }
      try {
        const res = await $typesense
          .collections(collection.value)
          .documents()
          .search({ ...searchParameters.value, q, page: page + 1, per_page })

        hits[page] = res.hits
        totalHits.value = res.found

        return hits.value[page]
      } catch (err) {
        console.error(err)
      }
    }
  })

  return {
    // selectedFilters,
    // filterBy
    // searchParameters,
    // pageProvider
  }
}
